//#region IMPORTS
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
import { Listbox } from "@headlessui/react";
import classNames from "../../helpers/classNames";
import { StoreFormat } from "../../models/storeFormat";
//#endregion

//#region INTERFACE
interface Props {
  onChangeHandler: (storeFormats: StoreFormat[]) => void;
  selectedValues?: StoreFormat[];
  disabled?: boolean;
  tooltipId: string;
  loading?: boolean;
  items: StoreFormat[];
}
//#endregion

export default function InstoreTypeFormStoreFormatSelector({
  onChangeHandler,
  selectedValues,
  disabled = false,
  loading = false,
  tooltipId,
  items,
}: Props) {
  //#region RENDER
  return (
    <Listbox
      value={selectedValues ? selectedValues : undefined}
      onChange={onChangeHandler}
      multiple
    >
      <div className="relative">
        <Listbox.Button
          type="button"
          className={classNames(
            disabled ? "cursor-not-allowed" : "",
            "block w-full rounded-md border-0 py-1.5 text-gray-900 text-left pl-3 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:font-light focus:ring-2 focus:ring-inset focus:ring-slate-600 sm:text-sm sm:leading-6"
          )}
          data-tooltip-id={tooltipId}
          data-tooltip-content={selectedValues?.map((sv) => sv.name).join(", ")}
        >
          <span
            className={classNames(
              selectedValues && selectedValues?.length > 0
                ? "text-gray-900"
                : "text-gray-400",
              "block truncate"
            )}
          >
            {selectedValues && selectedValues.length > 1 ? (
              <Fragment>
                <span className="font-medium">{selectedValues[0].name}</span>{" "}
                and{" "}
                <strong className="text-rose-600">
                  {selectedValues.length - 1}
                </strong>{" "}
                more...
              </Fragment>
            ) : selectedValues && selectedValues.length === 1 ? (
              selectedValues[0].name
            ) : loading ? (
              "loading store formats"
            ) : (
              "select a store format"
            )}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon className={classNames("text-gray-400 size-5")} />
          </span>
          {selectedValues && selectedValues.length > 1 && (
            <Tooltip id={tooltipId} />
          )}
        </Listbox.Button>
        <Listbox.Options className="absolute z-20 mt-1 min-h-12 max-h-28 w-full overflow-auto rounded-lg bg-gray-100 p-2 text-sm shadow-md">
          {items.map((item) => (
            <Listbox.Option
              disabled={disabled}
              key={item.id}
              value={item}
              className="text-gray-900 relative cursor-default rounded-md select-none py-1 pl-3 pr-9"
            >
              {selectedValues?.map((sv) => sv.id)?.includes(item.id) ? (
                <span className="text-indigo-600 absolute inset-y-0 right-0 flex items-center pr-4">
                  <CheckIcon aria-hidden="true" className="size-5" />
                </span>
              ) : null}
              <span
                className={classNames(
                  selectedValues?.map((sv) => sv.id)?.includes(item.id)
                    ? "font-bold"
                    : "font-normal",
                  "block truncate"
                )}
              >
                {item.name}
              </span>
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </div>
    </Listbox>
  );
  //#endregion
}
